import React, { useState } from 'react'
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import ActionList from './bulk-actions/ActionList';

const BulkActions = (props) => {
    const {toggleSelectAll, refreshPartner, partners, listSelected} = props
    const [isOpen, setIsOpen] = useState(false)

    const _showModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
        toggleSelectAll(false)
        refreshPartner()
    }

    return (
        <UncontrolledDropdown className='MenuActions'>
            <DropdownToggle tag='span' className='ToggleActions'>
                <span
                    className='border rounded d-inline-flex px-2 py-1 bg-light font-weight-normal align-items-baseline'>
                    Hành động <i className="fa fa-caret-down ml-2" />
                </span>
            </DropdownToggle>

            <DropdownMenu> 
                <ActionList
                    {...props}
                    isOpen={isOpen}
                    showModal={_showModal}
                    closeModal={_closeModal}
                />
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default BulkActions
